import { useEffect, useState } from "react";
import { fetchNicheRollup } from "../../core/api/nicheRollupApi";

// The account's niche roll-up, loaded when the Audits page opens (Industry
// Audits accounts only), separately from the Snapshots list, so a slow or
// failed roll-up never holds the list up. Loaded again whenever reload
// changes (a Snapshot finished or was stopped); the last result stays on
// screen meanwhile. { status: "off" | "loading" | "ready" | "error", rollup, ms }.
export default function useNicheRollup(agencyId, enabled, reload = 0) {
  const [state, setState] = useState({ status: "loading", rollup: null, ms: null });

  useEffect(() => {
    if (!enabled || !agencyId) return undefined;
    let cancelled = false;
    const started = Date.now();
    setState(prev => (prev.status === "ready" ? prev : { status: "loading", rollup: null, ms: null }));
    fetchNicheRollup(agencyId).then(
      rollup => { if (!cancelled) setState({ status: "ready", rollup, ms: Date.now() - started }); },
      error => {
        console.error("fetchNicheRollup", error);
        if (!cancelled) setState(prev => (prev.status === "ready" ? prev : { status: "error", rollup: null, ms: Date.now() - started }));
      },
    );
    return () => { cancelled = true; };
  }, [agencyId, enabled, reload]);

  return enabled && agencyId ? state : { status: "off", rollup: null, ms: null };
}
